// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__Kr7Ku","error":"style_error__xDxP4","large":"style_large__p7UXV","warning":"style_warning__aUh2A","success":"style_success__kDEDM"};